/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Substance } from "./Substance";
import {
  SubstanceFromJSON,
  SubstanceFromJSONTyped,
  SubstanceToJSON,
  SubstanceToJSONTyped,
} from "./Substance";

/**
 *
 * @export
 * @interface PaginatedSubstanceList
 */
export interface PaginatedSubstanceList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<Substance>;
}

/**
 * Check if a given object implements the PaginatedSubstanceList interface.
 */
export function instanceOfPaginatedSubstanceList(value: object): value is PaginatedSubstanceList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedSubstanceListFromJSON(json: any): PaginatedSubstanceList {
  return PaginatedSubstanceListFromJSONTyped(json, false);
}

export function PaginatedSubstanceListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedSubstanceList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(SubstanceFromJSON),
  };
}

export function PaginatedSubstanceListToJSON(json: any): PaginatedSubstanceList {
  return PaginatedSubstanceListToJSONTyped(json, false);
}

export function PaginatedSubstanceListToJSONTyped(
  value?: PaginatedSubstanceList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(SubstanceToJSON),
  };
}
